var amt_admin = require('amt_admin').default;
var app = require("angular").module("ww2_analytics.admin_restore", [
  amt_admin
]);

app.service("restore_api", [
  "jsonrpc",
  function(jsonrpc) {
    var service = jsonrpc.newService("restore");
    this.get_restore_tasks = service.createMethod("get_restore_tasks");
    this.restore_from_kafka = service.createMethod("restore_from_kafka");
    this.consume_events = service.createMethod("consume_events");
    this.delete_task = service.createMethod("delete_task");
    this.delete_all_restore_tables = service.createMethod(
      "delete_all_restore_tables"
    );
  }
]);

var restore_tpl = require("./main.html");

app.config([
  "$stateProvider",
  function($stateProvider) {
    $stateProvider.state("amt.ww2.admin.restore", {
      url: "/restore",
      template: restore_tpl,
      data: {
        priority: 103,
        title: "Restore from Kafka",
        role: "admin",
        hidden_filters: true
      },
      resolve: {
        tasks: [
          "restore_api",
          function(restore_api) {
            return restore_api.get_restore_tasks({});
          }
        ]
      },
      controller: [
        "$scope",
        "tasks",
        "restore_api",
        function($scope, tasks, restore_api) {
          $scope.tasks = tasks;
          $scope.start = function(model) {
            restore_api.restore_from_kafka({
              kafka_topic: model.topic,
              event_names: model.tables,
              from_datetime: "",
              to_datetime: ""
            });
          };
          $scope.consume_events = function(task_id) {
            restore_api.consume_events({
              task_id: task_id
            });
          };
          $scope.delete_task = function(task_id) {
            restore_api.delete_task({
              task_id: task_id
            });
          };
          $scope.delete_all_restore_tables = function(task_id) {
            restore_api.delete_all_restore_tables({
              task_id: task_id
            });
          };
        }
      ]
    });
  }
]);

export default app.name;
